import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="scroll-mt-24 border-b border-navy/10 bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>Projects</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Selected work
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          <Reveal>
            <Link
              to="/doccare"
              data-testid="project-card-doccare"
              className="group flex h-full flex-col border border-navy/15 bg-cream transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-navy/40"
            >
              <div className="flex h-44 items-end justify-between bg-navy p-6">
                <p className="font-display text-3xl font-semibold tracking-tight text-cream">
                  DocCare
                </p>
                <ArrowUpRight className="h-6 w-6 text-rust transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <p className="text-xs font-medium uppercase tracking-[0.2em] text-rust">
                  Healthcare · Product Case Study
                </p>
                <p className="mt-3 text-sm leading-relaxed text-navy/70">
                  Appointment-booking product concept — from business
                  requirements and product definition to a working application.
                </p>
                <p className="mt-auto pt-5 text-xs text-navy/45">
                  Role: Business Analyst | Product Consultant
                </p>
              </div>
            </Link>
          </Reveal>
          {[0, 1].map((i) => (
            <Reveal key={i} delay={0.08 * (i + 1)}>
              <div
                data-testid={`project-card-coming-soon-${i}`}
                className="flex h-full flex-col items-start justify-between border border-dashed border-navy/25 bg-white p-6"
              >
                <span className="rounded-full bg-sage/50 px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.15em] text-navy/60">
                  Coming Soon
                </span>
                <p className="mt-16 text-sm leading-relaxed text-navy/50">
                  A new product case study is being documented and will be
                  published here.
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
